import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import moment from 'moment/moment';
import { Helmet } from "react-helmet";

import './Resources/dashboard.css';
import axios from '../axios.js';
import Navbar from './Supportingfiles/navbar.js';
import Sidebar from './Supportingfiles/sidebar.js';
//import Create_customers from './create_customers';
import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import Chart from "chart.js/auto";
import { Line, Bar } from "react-chartjs-2";


//EXCEL DOWNLOAD IMPORT
//import * as XLSX from 'xlsx';
//import { saveAs } from 'file-saver';

function Team_createuser(){




    //Invoice Print Function
    const componentRef = useref();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });
    
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");



   //FILTER VARIABLES

   
  //Variables for pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageNumber, setpageNumber] = useState(1);
     

  //filter_val
  const[filterval,setfilterval]=useState(0);
  const[errorvar,seterrorvar]=useState();

  //Variables
const[data,setData] = useState([]);//SetData Variable




  const[username,setusername]=useState();const updateusername = (event) => { setusername(event.target.value);}; const[username_er,setusername_er]=useState();
  const[password,setpassword]=useState();const updatepassword = (event) => { setpassword(event.target.value);}; const[password_er,setpassword_er]=useState();
  const[cpassword,setcpassword]=useState();const updatecpassword = (event) => { setcpassword(event.target.value);}; const[cpassword_er,setcpassword_er]=useState();
  const[name,setname]=useState();const updatename = (event) => { setname(event.target.value);}; const[name_er,setname_er]=useState();
  const[contact,setcontact]=useState();const updatecontact = (event) => { setcontact(event.target.value);}; const[contact_er,setcontact_er]=useState();
  const[whatsapp,setwhatsapp]=useState();const updatewhatsapp = (event) => { setwhatsapp(event.target.value);}; const[whatsapp_er,setwhatsapp_er]=useState();
  const[email,setemail]=useState();const updateemail = (event) => { setemail(event.target.value);}; const[email_er,setemail_er]=useState();
  const[type,settype]=useState();const updatetype = (event) => { settype(event.target.value);}; const[type_er,settype_er]=useState();
  const[category,setcategory]=useState();const updatecategory = (event) => { setcategory(event.target.value);}; const[category_er,setcategory_er]=useState();
  const[address,setaddress]=useState();const updateaddress = (event) => { setaddress(event.target.value);}; const[address_er,setaddress_er]=useState();
  const[city,setcity]=useState();const updatecity = (event) => { setcity(event.target.value);}; const[city_er,setcity_er]=useState();
  const[state,setstate]=useState();const updatestate = (event) => { setstate(event.target.value);}; const[state_er,setstate_er]=useState();
  const[country,setcountry]=useState();const updatecountry = (event) => { setcountry(event.target.value);}; const[country_er,setcountry_er]=useState();
  const[pincode,setpincode]=useState();const updatepincode = (event) => { setpincode(event.target.value);}; const[pincode_er,setpincode_er]=useState();
  const[company_name,setcompany_name]=useState();const updatecompany_name = (event) => { setcompany_name(event.target.value);}; const[company_name_er,setcompany_name_er]=useState();
  const[details,setdetails]=useState();const updatedetails = (event) => { setdetails(event.target.value);}; const[details_er,setdetails_er]=useState();
  const[user_status,setuser_status]=useState();const updateuser_status = (event) => { setuser_status(event.target.value);}; const[user_status_er,setuser_status_er]=useState();
  

 //ERROR VARIABLES 
 const[error_msg,seterror_msg]=useState();


/***************** ADD TEAM MEMBER FUNCTION START  ******************/
function createuser(){

  
  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){


    //Setting Error Variables
    setusername_er(" ");setpassword_er(" ");setcpassword_er(" ");setname_er(" ");setcontact_er(" ");setwhatsapp_er(" ");setemail_er(" ");settype_er(" ");setcategory_er(" ");
    setaddress_er(" "); setcity_er(" "); setstate_er(" "); setcountry_er(" "); setpincode_er(" "); setcompany_name_er(" ");setdetails_er(" "); setuser_status_er(" "); seterror_msg(" ");
   
    
//Fetching Form Data
let noerror = 0;
let $username = document.getElementById("username").value; if($username==""){ setusername_er("Username is required !");noerror = noerror+1; }//username
let $password = document.getElementById("password").value; if($password==""){ setpassword_er("Password is required !");noerror = noerror+1; }//password
let $cpassword = document.getElementById("cpassword").value; if($cpassword==""){ setcpassword_er("Confirm Password is required !");noerror = noerror+1; }//cpassword
let $name = document.getElementById("name").value; if($name==""){ setname_er("Name is required !");noerror = noerror+1; }//name
let $contact = document.getElementById("contact").value; if($contact==""){ setcontact_er("Contact is required !");noerror = noerror+1; }//contact
let $whatsapp = document.getElementById("whatsapp").value; //if($whatsapp==""){ setwhatsapp_er("Whatsapp is required !");noerror = noerror+1; }//whatsapp
let $email = document.getElementById("email").value; if($email==""){ setemail_er("Email is required !");noerror = noerror+1; }//email
let $type = document.getElementById("type").value; if($type==""){ settype_er("Type is required !");noerror = noerror+1; }//type
let $category = document.getElementById("category").value; if($category==""){ setcategory_er("Category is required !");noerror = noerror+1; }//category

let $address = document.getElementById("address").value; //address
let $city = document.getElementById("city").value; //city
let $state = document.getElementById("state").value; //state
let $country = document.getElementById("country").value; //country
let $pincode = document.getElementById("pincode").value; //pincode
let $details = document.getElementById("details").value; //details
let $company_name = document.getElementById("company_name").value; if($company_name==""){ setcompany_name_er("Company Name is required !");noerror = noerror+1; }//company_name
let $user_status = document.getElementById("user_status").value; if($user_status==""){ setuser_status_er("User Status is required !");noerror = noerror+1; }//user_status


//No primary errors
if(noerror==0){

  const addBtn = document.getElementById("submit-btn");
  addBtn.disabled = true;
  addBtn.innerText = "Processing..."; // optional


    //disabling button
    document.getElementById('submit-btn').disabled = true; 


  //Sending Data through axios
  axios.post("create-new-user", { 
  Log_id:logid,
  Token:token,
  Username:$username,
  Password:$password,
  Confirm_password:$cpassword,
  Name:$name,
  Contact:$contact,
  Whatsapp:$whatsapp,
  Email:$email,
  Type:$type,
  Category:$category,
  Address:$address,
  City:$city,
  State:$state,
  Country:$country,
  Pincode:$pincode,
  Details:$details,
  Company_name:$company_name,
  User_status:$user_status,
  
  },{
    headers: { "Content-Type": "multipart/form-data" },
    }
    )
  
  .then((response) => {
     
    // In case of network or server error
    addBtn.disabled = false;
    addBtn.innerText = "Create User";

      //enabling button
     // document.getElementById('submit-btn').disabled = false; 

  //Validation Errors
  if(response.data.validatorerror){
  setusername_er(response.data.validatorerror.Username);
  setpassword_er(response.data.validatorerror.Password);
  setcpassword_er(response.data.validatorerror.Confirm_password);
  setname_er(response.data.validatorerror.Name);
  setcontact_er(response.data.validatorerror.Contact);
  setwhatsapp_er(response.data.validatorerror.Whatsapp);
  setemail_er(response.data.validatorerror.Email);
  settype_er(response.data.validatorerror.Type);
  setcategory_er(response.data.validatorerror.Category);
  setaddress_er(response.data.validatorerror.Address);
  setcity_er(response.data.validatorerror.City);
  setstate_er(response.data.validatorerror.State);
  setcountry_er(response.data.validatorerror.Country);
  setpincode_er(response.data.validatorerror.Pincode);
  setdetails_er(response.data.validatorerror.Details);
  setcompany_name_er(response.data.validatorerror.Company_name);
  setuser_status_er(response.data.validatorerror.User_status);
  seterror_msg("Cannot Create User !");
  
  
  }
  //Invalid Entries
  if(response.data.error==102){ 

//  settraining_name_er(response.data.validatorerror.Training_name);
  setusername_er(response.data.username_er);
  setpassword_er(response.data.password_er);
  setcpassword_er(response.data.cpassword_er);
  setname_er(response.data.name_er);
  setcontact_er(response.data.contact_er);
  setwhatsapp_er(response.data.whatsapp_er);
  setemail_er(response.data.email_er);
  settype_er(response.data.type_er);
  setcategory_er(response.data.category_er);
  setaddress_er(response.data.address_er);
  setcity_er(response.data.city_er);
  setstate_er(response.data.state_er);
  setcountry_er(response.data.country_er);
  setpincode_er(response.data.pincode_er);
  setdetails_er(response.data.details_er);
  setcompany_name_er(response.data.company_name_er);
  setuser_status_er(response.data.user_status_er);
  seterror_msg("Cannot Create User !");
  
  
  }
  
  //Invalid Errors
  if(response.data.error==103){  seterror_msg(response.data.error_msg); return; }
  
  //Success
  if(response.data.successvar==1){ 
    
   setusername(" ");setpassword(" ");setcpassword(" ");setname(" ");setcontact(" ");setwhatsapp(" ");setemail(" ");settype(" ");setcategory(" ");
   setaddress(" "); setcity(" "); setstate(" "); setcountry(" "); setpincode(" "); setcompany_name(" ");setdetails(" "); setuser_status(" "); seterror_msg(" ");

    document.getElementById("success-card").style.display="block"; }

  //failure
  if(response.data.successvar==6){ seterror_msg("Cannot Add Team Member !"); }

  //Session Expired
  if(response.data.successvar==100){ seterror_msg("Session Expired !");  }


  }    );
  
  }
  

  }
  //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
 sessionStorage.removeItem("logStatus00");
 sessionStorage.removeItem("logId00");
 sessionStorage.removeItem("logToken00");
 sessionStorage.removeItem("logName00");
 
 window.location.replace("/");
 
 
 }    

}

/***************** CREATE TRAINING FUNCTION END  ******************/


 
return(
    <>
      <Helmet>
            <meta name="robots" content="noindex,nofollow" />
      </Helmet>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>BUSINESS SAMADHAN | DOCUMENT MANAGEMENT SYSTEM</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

      <Sidebar />
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">

        {/* CREATE SUCCESS CARD START */}
       <div class="d-flex justify-content-center">
               <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-primary">User Created Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to continue.</p>
                      <a><button class="mt-3 btn btn-outline-primary"  onClick={()=>{
                       // sessionStorage.removeItem("EditId");
                        document.getElementById("success-card").style.display="none";
                        
                      }}>Continue</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
       </div>
      {/* CREATE SUCCESS CARD END */}

            <div className="page-header flex-wrap">
            <div className="header-left">  
           
            </div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">USER PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">CREATE NEW USER</p>
                  </a>
                </div>

              </div>
            </div>

            {/*} chart row starts here */}
            <div className="row">

          
            </div>

          
            <div className="row">
              <div className="col-12 grid-margin">
          
            {/* CREATE LICENSE FORM START */}
            <div class="card">
              
                  <div class="card-body" style={{textAlign:"left"}}>
                    <h4 class="card-title">Create New User</h4>
                    <div class="form-sample">
                      <p class="card-description">create new user</p>
                      <code>{error_msg}</code>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Username<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="username" placeholder="Username" value={username} onChange={updateusername} />
                              <code>{username_er}</code>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="name"  placeholder="Member Code" value={name} onChange={updatename} />
                              <code>{name_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Password<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="password" class="form-control" id="password" placeholder="***********" value={password} onChange={updatepassword} />
                              <code>{password_er}</code>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Confirm Password<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="password" class="form-control" id="cpassword"  placeholder="***********" value={cpassword} onChange={updatecpassword} />
                              <code>{cpassword_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Email<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="email" value={email} placeholder="email" onChange={updateemail} />
                              <code>{email_er}</code>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">User Status<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" id="user_status" value={user_status} placeholder="1" onChange={updateuser_status} style={{padding:"1rem"}}>
                              <option value="active">active</option>
                              <option value="inactive">inactive</option>
                              </select>
                              <code>{user_status_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="type" value={type} placeholder="Type" onChange={updatetype} />
                              <code>{type_er}</code>
                            </div>
                          </div>
                        </div>
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Category<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="category" value={category} placeholder="category" onChange={updatecategory} />
                              <code>{category_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                         <div class="col-md-6" id="ifr">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Contact<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="contact" value={contact} placeholder="918000000000" onChange={updatecontact} />
                              <code>{contact_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6" id="ifr1">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Whatsapp</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="whatsapp" value={whatsapp} placeholder="918000000000" onChange={updatewhatsapp} />
                              <code>{whatsapp_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                         <div class="col-md-6" id="ifr">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Company Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="company_name" value={company_name} placeholder="Mumbai" onChange={updatecompany_name} />
                              <code>{company_name_er}</code>
                            </div>
                          </div>
                        </div>           
                        </div>
                        <div class="row">
                        <div class="form-group">
                        <label for="exampleTextarea1">Address</label>
                        <textarea  class="form-control" rows="2" placeholder="write address" id="address" value={address} onChange={updateaddress} ></textarea>
                        <code>{address_er}</code>
                        </div>
                        </div>
                        <div class="row">
                         <div class="col-md-6" id="ifr">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">City</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="city" value={city} placeholder="Mumbai" onChange={updatecity} />
                              <code>{city_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6" id="ifr1">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">State</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="state" value={state} placeholder="Maharashtra" onChange={updatestate} />
                              <code>{state_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                         <div class="col-md-6" id="ifr">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Country</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="country" value={country} placeholder="India" onChange={updatecountry} />
                              <code>{country_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6" id="ifr1">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Pincode</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="pincode" value={pincode} placeholder="4200001" onChange={updatepincode} />
                              <code>{pincode_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="form-group">
                        <label for="exampleTextarea1">Details</label>
                        <textarea  class="form-control" rows="2" placeholder="write details here" id="details" value={details} onChange={updatedetails} ></textarea>
                        <code>{details_er}</code>
                        </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <button class="btn btn-lg btn-primary" style={{fontWeight:"bold"}} onClick={createuser} id="submit-btn">Create User</button>
                         </div>
                        </div>
                      
                    </div>
                  </div>
                </div>
            {/* CREATE LICENSE FORM END */}

              </div>
          </div>

            


          {/*}  <button type="button" style={{backgroundColor:"#196fb0",marginTop:"2rem",marginLeft:"2rem"}} class="btn btn-secondary btn-icon-text" onClick={handlePrint}> Print <i class="mdi mdi-file-document"></i>
            </button>
            <button class="btn btn-dark" style={{marginTop:"2rem",marginLeft:"2rem"}} onClick={getexcelData}><i class="mdi mdi-file-excel text-light"></i> Download</button>
          */}
           <br/><br/><br/>
            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

//}
}
export default Team_createuser;